<template>
    <div>
        <ConfirmDialog
            :is-open="updateScreenDialog"
            :data="screen"
            :action-loading="updateScreenLoading"
            @on-confirm="updateScreen"
            @on-abort="closeUpdateScreenDialog"
        >
            <template v-if="screen.inCampaign" #content>
                Czy na pewno chcesz wyłączyć ekran?
            </template>
            <template v-else #content>
                Czy na pewno chcesz włączyć ekran?
            </template>
            <template #confirmButton>
                Potwierdź
            </template>
        </ConfirmDialog>
        <ImagePreviewDialog
            :is-open="imagePreviewDialog"
            :file-preview-uri="filePreviewURI"
            @on-close="closeImagePreviewDialog"
        />

        <v-dialog
            :value="isOpen"
            max-width="900px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Ekrany
                    </h1>
                </v-card-title>
                <v-card-text v-if="outdoorsCampaignLocalizationScreens.length > 0">
                    <v-data-table
                        :headers="headers"
                        :items="outdoorsCampaignLocalizationScreens"
                        disable-pagination
                        hide-default-footer
                        :mobile-breakpoint="0"
                    >
                        <template #item.ordinalNumber="{item}">
                            {{ item.localizationScreen.ordinalNumber }}
                        </template>
                        <template #item.localizationScreenGroup="{item}">
                            {{ item.localizationScreen.localizationScreenGroup.name }}
                        </template>
                        <template #item.localizationScreenSize="{item}">
                            {{ item.localizationScreen.localizationScreenSize.sizeA }} x {{ item.localizationScreen.localizationScreenSize.sizeB }}
                        </template>
                        <template #item.inCampaign="{item}">
                            <template>
                                <v-icon
                                    v-if="item.inCampaign"
                                    small
                                    color="success"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon v-else small color="error">
                                    mdi-close
                                </v-icon>
                            </template>
                        </template>
                        <template #item.isDone="{item}">
                            <template v-if="item.inCampaign">
                                <template>
                                    <v-icon
                                        v-if="item.inCampaign && item.isDone"
                                        small
                                        color="success"
                                    >
                                        mdi-check
                                    </v-icon>
                                    <v-icon v-else small color="error">
                                        mdi-close
                                    </v-icon>
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.campaignProduct="{item}">
                            <template v-if="item.campaignProduct">
                                <template v-if="item.campaignProduct.campaignProductAttachments.length > 0">
                                    <img
                                        width="75"
                                        :src="taskPreviewURI(item.campaignProduct.campaignProductAttachments[0].fileThumbnail)"
                                        @click="showFilePreviewDialog(item.campaignProduct.campaignProductAttachments[0].filePreview)"
                                    >
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </template>
                            <template v-else>
                                -
                            </template>
                        </template>
                        <template #item.actions="{item}">
                            <div class="d-inline-flex">
                                <v-tooltip :open-delay="tooltipDelay" top>
                                    <template #activator="{on}">
                                        <v-btn
                                            icon
                                            :data-sentry-label="item.inCampaign ? 'Wyłącz' : 'Włącz'"
                                            v-on="on"
                                            @click="showUpdateScreenDialog(item)"
                                        >
                                            <v-icon color="pink">
                                                mdi-eye-off
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span v-if="item.inCampaign">Wyłącz</span>
                                    <span v-else>Włącz</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </v-data-table>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Anuluj"
                        @click="onClose()"
                    >
                        Anuluj
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'
import ConfirmDialog from '@/components/common/ConfirmDialog'
import ImagePreviewDialog from '@/components/common/ImagePreviewDialog'
import { apiConfig } from '@/config'

export default {
    name: 'OutdoorsLocalizationScreens',
    components: {
        ConfirmDialog,
        ImagePreviewDialog

    },
    mixins: [ tooltipDelay ],
    props: {
        isOpen: {
            type: Boolean
        },
        localizationData: {
            type: Object,
            default: null
        },
    },
    data() {
        return {
            screen: {},
            localization: {},
            updateScreenDialog: false,
            updateScreenLoading: false,
            imagePreviewDialog: false,
            filePreviewURI: null,
            headers: [
                {
                    text: 'Numer ekranu',
                    value: 'ordinalNumber',
                    sortable: false,
                },
                {
                    text: 'Grupa',
                    value: 'localizationScreenGroup',
                    sortable: false,

                },
                {
                    text: 'Wymiar',
                    value: 'localizationScreenSize',
                    sortable: false,

                },
                {
                    text: 'W kampanii',
                    value: 'inCampaign',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Zakończony',
                    value: 'isDone',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Podgląd grafiki produktu',
                    value: 'campaignProduct',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 100
                },

            ]
        }
    },
    computed: {
        outdoorsCampaignLocalizationScreens() {
            return this.$store.state.outdoors.outdoorsCampaigns.outdoorsCampaigns.outdoorsCampaignLocalizationScreens
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.localization = JSON.parse(JSON.stringify(this.localizationData))
            }
        }
    },
    methods: {
        taskPreviewURI(image) {
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            return `${mediaRoot}${image}`
        },
        showFilePreviewDialog(image) {
            this.filePreviewURI = this.taskPreviewURI(image)
            this.imagePreviewDialog = true
        },
        closeImagePreviewDialog() {
            this.imagePreviewDialog = false
        },
        async getOutdoorsCampaignLocalizationScreen(screen) {
            return await this.$store.dispatch('outdoors/outdoorsCampaigns/getOutdoorsCampaignLocalizationScreen', screen.id)
                .then(response => {
                    this.screen = response.data
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showUpdateScreenDialog(screen) {

            this.getOutdoorsCampaignLocalizationScreen(screen).then(() => {
                this.updateScreenDialog = true
            })
        },
        updateScreen(screen) {
            this.updateScreenLoading = true
            screen.inCampaign = !screen.inCampaign
            this.$store.dispatch('outdoors/outdoorsCampaigns/updateOutdoorsLocalizationScreen', screen)
                .then(() => {
                    this.$emit('get-campaign-localization-screens')
                    this.$emit('get-campaign-localizations')
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.updateScreenLoading = false
                    this.closeUpdateScreenDialog()
                })
        },
        closeUpdateScreenDialog() {
            this.updateScreenDialog = false

            setTimeout(() => {
                this.screen = {}
            }, 500)
        },
        onClose() {
            setTimeout(() => {
                this.localization = {}
            }, 500)
            this.$emit('on-close')
        },
    },
}
</script>